import React, { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import AppContext from "../../container/context";
import { Box, CircularProgress } from "@mui/material";
import ActionTable from "../../components/table/ActionTable";

export default function Lista({ history, location }) {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [lista, setLista] = useState([]);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = () => {
    setCarregando(true);
    api
      .get("carrinhos/listar")
      .then((res) => {
        setCarregando(false);
        setLista(res);
      })
      .catch((err) => {
        console.log(err);

        notification(
          "error",
          "Erro ao listar os carrinhos do usuário."
        );
      });
  };

  const abrirCarrinho = (registro) => {
    history.push(`/app/quinzenas-carrinhos/carrinho/${registro.usuarioId}/${registro.escolaId}`);
  };

  const tRegistros = {
    title: "Carrinhos Ativos",
    onLineClick: abrirCarrinho,
    newItemAction: () => history.push(`/app/quinzenas-carrinhos/catalogo`),
    columns: [
      {
        name: "escolaNome",
        label: "Escola",
      },
      {
        name: "qtdProdutos",
        label: "Produtos",
      },
      {
        name: "qtdTotalItens",
        label: "Quantidade total de itens",
      },
    ],
    array: lista,
  };

  return (
    <div>
      {carregando ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </Box>
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
